firebird.controller('camaroLeaveModalCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'logService',
    'socketService',
    'meetingService',
    'attendeeService',
    'camaroService',
    'helperService',
    'annotationService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        logService,
        socketService,
        meetingService,
        attendeeService,
        camaroService,
        helperService,
        annotationService
    ) {
        const self = this;

        const logger = new LogServiceWrapper(logService, 'camaroLeaveModalCtrl');

        self.modalState = 'closed';

        self.cancel = cancel;
        self.leaveMeeting = leaveMeeting;
        self.endMeeting = endMeeting;
        self.hasEndAbility = hasEndAbility;
        self.isRedirectSupported = isRedirectSupported;

        self.endRedirectUrl = '';

        self.isWebinar = meetingService.isWebinar();

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        ////////////////////////

        function onShowModal(e, modalName, data) {
            if (modalName === 'camaroLeaveSelection') {
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    // VDI - Hide video stream in device selection modal when leave meeting modal is shown.
                    $rootScope.$broadcast('toggle-modal-on-preview', true);
                }
                if (data && data.skipConfirmation === true) {
                    logger.log(
                        'onShowModal',
                        'calling camaroLeaveModalCtrl.endMeeting because skipConfirmation was set'
                    );
                    self.endMeeting();
                    return;
                }

                if (attendeeService.getIsHost()) {
                    self.endRedirectUrl = meetingService.getExitUrl();
                }

                logger.log('onShowModal', 'showing modal camaroLeaveModalCtrl');
                self.modalState = 'open';
                $window.addEventListener('keydown', handleKeyDown);
                digest();
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('camaroLeaveSelection') !== -1) {
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    // VDI - Show video stream in device selection modal when leave meeting modal is closed.
                    $rootScope.$broadcast('toggle-modal-on-preview', false);
                }
                self.modalState = 'closed';
                $window.removeEventListener('keydown', handleKeyDown);
                digest();
            }
        }

        function isRedirectSupported() {
            return attendeeService.getIsHost() && !helperService.isUniteApplication();
        }

        function hasEndAbility() {
            return attendeeService.getIsHost();
        }

        function stopAdditionalServices() {
            if (annotationService.getIsInitiator()) {
                annotationService.stopAnnotation();
            } else {
                annotationService.disconnect();
            }
        }

        function handleKeyDown(event) {
            const escKey = 27;
            if (event.keyCode === escKey) {
                event.preventDefault();
                self.cancel();
            }
        }

        function cancel() {
            //cancel resets the service variables and closes
            camaroService.reset();
            close();
        }

        //TODO: add a check to the closing state for when we add menu naviation in later
        function leaveMeeting() {
            logger.log('leaveMeeting', 'calling camaroLeaveModalCtrl.leaveMeeting ...');
            camaroService.setIsUnloading(true);
            stopAdditionalServices();

            close();
            logger.log('leaveMeeting', 'calling terminate from camaroLeaveModalCtrl.leaveMeeting');
            socketService.terminate(attendeeService.getAttendantId());

            // we should release media resources before closing meeting window
            // without it audio track's 'ended' event fired and we see a
            // "microphone disconnected" popup for a moment ANYAM-103576
            meetingService.endMeeting();

            if (!camaroService.getIsMeetingInitiated()) {
                if (camaroService.getIsNavigating()) {
                    $window.location = camaroService.getNavigationUrl();
                } else {
                    camaroService.closeWindow();
                }
            } else if (attendeeService.getIsHost()) {
                if (helperService.isUniteApplication()) {
                    camaroService.closeWindow();
                } else {
                    //this is a host leaving the meeting from in-meeting, but not using a naviation menu
                    //or closing the app.  Therefore, we're sending to account manager.
                    $window.location = helperService.getAccountManagerRedirectUrl();
                }
            }
        }

        //TODO: add a check to the closing state for when we add menu naviation in later
        function endMeeting() {
            logger.log('endMeeting', 'calling camaroLeaveModalCtrl.endMeeting ...');
            if (self.endRedirectUrl) {
                socketService.send({
                    message: 'meeting-end-redirect',
                    data: self.endRedirectUrl
                });
            }

            stopAdditionalServices();

            $timeout(function () {
                const msgObj = {
                    message: 'end-meeting',
                    data: {}
                };

                socketService.send(msgObj);

                if (helperService.isUniteApplication()) {
                    // send notification back to Main process
                    $window.preloadedApi.remote.ipcRenderer.sendEndMeeting();
                }

                $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
                if (!camaroService.getIsMeetingInitiated() && !camaroService.getIsNavigating()) {
                    camaroService.closeWindow();
                }
            }, 500);
        }

        function close() {
            onHideModal(null, 'camaroLeaveSelection');
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
